import React from "react";
import _ from "lodash";
import { url } from "lib/format";
import MenuNode from "./menu-node";
import LuvitComponent from "LuvitComponent";
import NavigationStore from "./Store";
import config from "../../config";

const NODE_NAME_ADMIN = "luvitadministration";
const NODE_NAME_DEVPLAN = "developmentplan";
const NODE_NAME_MYLEARNING = "mylearning";
const NODE_NAME_HELP = "mni_help";

export default class MainMenuNode extends LuvitComponent {
  constructor(context, props) {
    super(context, props, "Menu");

    this.goToPage = this.goToPage.bind(this);
  }

  isAncestorOfSelf(id) {
    let activeNode = this.props.menu[id];
    for (let n = activeNode; n; n = this.props.menu[n.parentId]) {
      if (n.itemId == this.props.node.itemId) return true;
    }
  }

  onExpand(event) {
    let currentTarget = event.currentTarget;
    window.setTimeout(
      () =>
        currentTarget.scrollIntoView({ behavior: "smooth", block: "start" }),
      50,
    );
    this.props.onExpand(this.props.node);
  }

  goToPage(e) {
    let { itemId, url: nodeURL, name } = this.props.node;

    let children = _.filter(this.props.menu, (v) => v.parentId === itemId);

    if (children.length == 0) {
      if (name !== NODE_NAME_ADMIN) {
        NavigationStore.activateNode(itemId);
        url(nodeURL);
      } else {
        e.preventDefault();
        var enterAdminUrl = (config.urlRoot + nodeURL).replace("//", "/");
        window.open(enterAdminUrl, "_blank");
      }
    }
  }

  doRender() {
    let { node, menu, expandable, isBt } = this.props;
    let expanded = this.isAncestorOfSelf(this.props.activeMenuId);
    let highlighted = node.itemId == this.props.highlightMenuId;
    let children = _.sortBy(
      _.filter(menu, (mi) => mi.parentId === node.itemId),
      "order",
    );
    let target = "_self";
    let nodeUrl = url(node.url);
    let label = this.l(node.name);

    if (isBt) {
      if (node.name == "competenceprofile")
        label = this.l("subgoalfullfillment");

      if (node.name == NODE_NAME_DEVPLAN) label = this.l("activities2");

      if (node.name == NODE_NAME_MYLEARNING)
        label = this.l("programsandprogress");
    }

    if (node.name === NODE_NAME_HELP) {
      target = "";
      label += ` - ${this.l("openinnewwindow")}`;
    }
    if (node.name.indexOf("inst_custom") === 0) {
      target = "";
      nodeUrl = "javascript:luvit.OpenWin('" + node.url + "')";
    }
    if (node.name === NODE_NAME_ADMIN) {
      target = "_blank";
    }

    return (
      <MenuNode
        type={"menu-expandlist-" + (node.parentId === -1 ? "header" : "item")}
        itemId={node.itemId}
        menunameId={node.name}
        url={nodeUrl}
        icon={node.icon}
        target={target}
        title={label}
        label={label}
        expanded={expandable && expanded}
        highlight={highlighted}
        goToPage={this.goToPage}
        onExpand={(event) => this.onExpand(event)}
        isBt
      >
        {children.map((c) => (
          <MainMenuNode key={c.itemId} {...this.props} node={c} />
        ))}
      </MenuNode>
    );
  }
}
